import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from '@eastsideco/salvo-ts';

import './TrustPilotWidget.scss';

@Component
export class TrustPilotWidget extends ThemeComponent {


    init() {
    }
}
